import { useMemo } from 'react';
import { stickersAll } from '@/mocks/memes';

export default function Hero({ onPick }: { onPick: () => void }) {
  const featured = useMemo(() => stickersAll.slice(0, 3), []);

  return (
    <section id="hero" className="relative overflow-hidden bg-background-50 pt-24 md:pt-28">
      {/* 装饰 */}
      <div className="pointer-events-none absolute -left-20 top-24 h-64 w-64 rounded-full bg-secondary-100/70 blur-3xl" />
      <div className="pointer-events-none absolute -right-24 top-40 h-72 w-72 rounded-full bg-primary-100/70 blur-3xl" />
      <div className="pointer-events-none absolute bottom-10 left-1/3 h-52 w-52 rounded-full bg-accent-100/70 blur-3xl" />

      <div className="relative mx-auto grid max-w-7xl items-center gap-10 px-4 py-10 md:grid-cols-2 md:px-6 md:py-16">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-700">
            <i className="ri-leaf-line text-sm" />
            吃瓜群众专用配图 · 持续更新
          </span>
          <h1 className="mt-5 font-heading text-4xl leading-tight text-foreground-950 md:text-5xl">
            吃瓜不停，
            <br />
            <span className="text-primary-600">表情</span>更不能少
          </h1>
          <p className="mt-5 max-w-lg text-base leading-relaxed text-foreground-700 md:text-lg">
            全网最好用的吃瓜群众表情包库：震惊、无语、偷笑看戏、蹲后续一应俱全。海量吃瓜专用表情与动图实时上新，一键保存，让每一次围观都更有梗。
          </p>
          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <button
              onClick={onPick}
              className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              立即挑选表情包
            </button>
            <button
              onClick={() => document.getElementById('guide')?.scrollIntoView({ behavior: 'smooth' })}
              className="whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm text-foreground-800 transition-colors hover:bg-background-100"
            >
              查看使用攻略
            </button>
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3 text-sm text-foreground-600">
            <span className="flex items-center gap-2">
              <i className="text-accent-600 ri-stack-line" /> 海量表情素材
            </span>
            <span className="flex items-center gap-2">
              <i className="text-secondary-600 ri-refresh-line" /> 每日实时上新
            </span>
            <span className="flex items-center gap-2">
              <i className="text-primary-600 ri-download-2-line" /> 免费一键保存
            </span>
          </div>
        </div>

        <div className="relative grid grid-cols-3 gap-3 md:gap-4">
          {featured.map((m, i) => (
            <div
              key={m.id}
              className={`overflow-hidden rounded-2xl border border-background-200 bg-background-50 ${
                i === 1 ? 'mt-8' : i === 2 ? 'mt-3' : ''
              }`}
            >
              <img
                src={m.img}
                alt={`吃瓜群众表情${m.phrase}`}
                title={`吃瓜表情 ${m.phrase}`}
                className="aspect-square w-full object-cover"
              />
            </div>
          ))}
          <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-accent-500 px-5 py-2 text-sm text-background-50 shadow-none">
            今日新增 +120
          </div>
        </div>
      </div>
    </section>
  );
}